<template>
  <vbt-content-box v-bind="$attrs">
    <template #title>
      <v-layout align-center>
        Information
        <ums-status-badge
          v-show="!$attrs.loading"
          :status="user.active ? 1 : 300"
          class="mx-2"
        >
          Status:
          <strong>
            {{ user.active ? 'Enabled' : 'Disabled' }}
          </strong>
        </ums-status-badge>
      </v-layout>
    </template>
    <v-layout
      :class="$_themeTextColorClass"
      align-center
    >
      <v-flex lg4>
        <strong>
          Name:
        </strong>
        {{ user.name }}
      </v-flex>
      <v-flex lg4>
        <strong>
          Email:
        </strong>
        {{ user.email }}
      </v-flex>
      <v-flex lg4>
        <v-layout align-center>
          <v-select
            v-model="tenant"
            :loading="isTenantsLoading"
            :items="tenants"
            label="Tenant"
            class="mr-3"
          />
          <v-btn
            :disabled="disableChangeTenantBtn"
            color="success"
            small
            @click="updateTenant"
          >
            Update
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
  </vbt-content-box>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { useStateFlag } from '@mixins/factories';
import { provideThemeSettings } from '@mixins';

import { wrapToLoadingFn } from '@helpers';

import {
  namespace as TenantsNamespace,
  ActionTypes as TenantsActionTypes,
} from '@modules/tenants/store.types';

import UsersApiService from '../_services/users.api.service';

export default {
  name: 'UmsUserInfoView',
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  mixins: [
    provideThemeSettings,
    useStateFlag('isTenantsLoading', 'setTenantsLoading'),
  ],
  data: () => ({ tenant: '' }),
  computed: {
    ...mapState(TenantsNamespace, {
      tenants: ({ allTenants }) => allTenants.map(({ name }) => name),
    }),
    disableChangeTenantBtn() {
      return this.tenant === this.user.tenant;
    },
  },
  watch: {
    'user.tenant': {
      handler(newValue) {
        this.tenant = newValue;
      },
      immediate: true,
    },
  },
  created() {
    this.getTenants();
  },
  methods: {
    ...mapActions(TenantsNamespace, {
      getTenants(dispatch) {
        this.wrapToLoadingFn({
          req: dispatch.bind({}, TenantsActionTypes.GET_ALL_TENANTS),
          loadingFlagName: 'isTenantsLoading',
        });
      },
    }),
    wrapToLoadingFn,
    updateTenant() {
      this.wrapToLoadingFn({
        req: UsersApiService.updateUserTenant.bind({}, {
          id: this.$route.params.id,
          tenant: this.tenant,
        }),
        fullscreenLoadingSpinner: true,
        onSuccess: () => {
          this.$VBlackerTheme.notification.success('User tenant successfully changed');
          this.$emit('change:success');
        },
      });
    },
  },
};
</script>
